import { BehaviorSubject, Subject, delayWhen, filter, first } from 'rxjs';
import { failedRequestManager } from './failed-requests'
import { DEFAULT_AZURE_UNIQUE_EP, UNIQUE_SIGNATURE } from './constants'
import { Railytics } from './railytics'
import { isbot } from 'isbot'
import { getDomain } from './utilities'
import { IdentifierService } from '@rai-analytics/rai-identifier-service';


const version = '0.0.1';


function getIdentifierService() {
  return new Promise<IdentifierService>((resolve, reject) => {
    if (window.Rai?.IdentifierService) {
      return resolve(window.Rai.IdentifierService)
    }
    const raiObj = window.Rai ?? {} as Rai
    window.Rai = new Proxy(raiObj, {
      set: (target, prop, newValue, receiver) => {
        const setted = Reflect.set(target, prop, newValue, receiver)
        if (prop === 'IdentifierService') {
          window.clearTimeout(timeoutId)
          window.setTimeout(() => {
            resolve(newValue as IdentifierService)
          })
        }
        return setted
      }
    })
    const timeoutId = window.setTimeout(() => {
      window.Rai = raiObj
      reject(new Error('Timeout IdentifierService'))
    }, 2e3)
  })
}

function getProfileManager() {
  return new Promise<ProfileManager>((resolve, reject) => {
    if (window.Rai?.ProfileManager) {
      return resolve(window.Rai.ProfileManager)
    }
    window.Rai = new Proxy(window.Rai ?? {} as Rai, {
      set(target, p, newValue, receiver) {
        const setted = Reflect.set(target, p, newValue, receiver)
        if (p === 'ProfileManager') {
          window.clearTimeout(timeoutId)
          window.setTimeout(() => {
            resolve(newValue as ProfileManager)
          })
        }
        return setted
      }
    })
    const timeoutId = window.setTimeout(() => {
      window.Rai.ProfileManager = {} as ProfileManager;
      reject(new Error('ProfileManager non definito'))
    }, 2000)
  })
}

const pageQueue$ = new BehaviorSubject<Record<string, string> | undefined>(undefined)
const mediaQueue$ = new Subject<Record<string, string>>()
const delay = pageQueue$.pipe(filter(Boolean), first())

const sendRaiWebTrackingFn = (identifierService: IdentifierService) => async (type: 'page' | 'action' | 'media', params: Record<string, string>) => {
  console.log('req:', type, JSON.stringify(params))
  const authorization = UNIQUE_SIGNATURE
  if (type === 'media' && !pageQueue$.value) {
    mediaQueue$.next(params)
    return
  }
  if (type === 'page') {
    pageQueue$.next(params)
  }

  const anonymized19: string = (await window.Rai.FingerPrintManager?.getFid()).anonymized19 || '';
  const bidData = await identifierService.getBid();

  if (isbot(navigator.userAgent)) {
    return;
  }

  const sessionData = await identifierService.getSid()

  const { s_id, anonym, carrier, city, country, startSession } = sessionData

  if (!params['cd']) {
    try {
      const profileManager = await getProfileManager();
      const user = profileManager.getUserProfile ? profileManager?.getUserProfile() : '';
      if (user) {
        params['cd'] = user['ua']
      } else {
        params['cd'] = ''
      }
    } catch { params['cd'] = '' }
  }
  params['b_id'] = anonymized19;
  params['s_id'] = s_id;
  params['city'] = city ?? '';
  params['country'] = country ?? '';
  params['anonym'] = anonym ?? '';
  params['carrier'] = carrier ?? '';
  params['session_start'] = `${startSession}`;
  if (type === 'media') {
    const pageEntries = Object.entries(pageQueue$.value ?? {}).filter(
      ([k,]) => k.startsWith('cp') || k.startsWith('cg') || k === 'pu'
    )
    const pageData = Object.fromEntries(pageEntries)
    params = { ...params, ...pageData }
  }
  let url = DEFAULT_AZURE_UNIQUE_EP
  url += `&ts_=${Date.now()}`
  params = Object.fromEntries(Object.entries(params).filter(([, v]) => !!v))
  const domain = getDomain(window.location.host);
  params['x-caller'] = `${domain + (domain.length ? ' ' : '')}web`;
  params['x-caller-version'] = version;

  const request = new Request(url, {
    method: 'POST',
    headers: {
      Authorization: authorization,
      'Content-Type': 'application/json; charset=utf-8',
      'X-Client-User-Agent': bidData?.['X-Client-User-Agent'] ?? navigator.userAgent
    },
    credentials: 'omit',
    body: JSON.stringify(params)
  })
  try {
    const response = await fetch(request)
    if (!response.ok) {
      failedRequestManager.set(request)
    }
  } catch {
    failedRequestManager.set(request)
  }
}

void (async function initSDK() {
  try {
    await getIdentifierService();
    const identifierService = window.Rai!.IdentifierService;
    console.log('rai-identifier-service installed');
    const fn = sendRaiWebTrackingFn(identifierService);
    if (!window.Rai?.RailyticsInstance) {
      window.Rai = window.Rai ?? {} as Rai;
      window.Rai.RailyticsInstance = new Railytics(fn, window.railyticsConfiguration ?? {});
    }
    mediaQueue$.pipe(
      delayWhen(() => delay),
    ).subscribe(val => {
      void fn('media', val)
    })
  } catch {
    /* empty */
  }
})()
